/* =====================================================================
   THE CLEAN SHAVE - HOMEPAGE CART HELPER (tcs-home-cart.js)
   Shopify AJAX cart adds for the combo + subscription sections.
   After a successful add: open Dawn's cart drawer when present,
   otherwise refresh the [data-cart-count] badge. Always dispatches a
   'tcs:cart:added' document event on success so the TCS cart drawer
   (tcs-drawer-search.js) can open and re-render.
   ===================================================================== */
(function () {
  if (window.tcsCart) return;

  function refreshBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (dot) {
          dot.textContent = c.item_count;
          dot.classList.toggle('on', c.item_count > 0);
          dot.classList.remove('bump');
          void dot.offsetWidth;
          dot.classList.add('bump');
        });
      })
      .catch(function () {});
  }

  /* items: [{ id: <variantId>, quantity: n, selling_plan?: id }] */
  function add(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
    var body = { items: items };
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var label;
    if (btn) {
      label = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
        if (!res.ok || res.data.status) {
          if (btn) {
            btn.textContent = 'Try again';
            setTimeout(function () { btn.textContent = label; }, 2200);
          }
          return res;
        }
        if (useDrawer && res.data.sections) {
          drawer.renderContents(res.data);
        }
        refreshBadge();
        try {
          document.dispatchEvent(new CustomEvent('tcs:cart:added', { detail: res.data }));
        } catch (err) { /* no CustomEvent support: drawer just will not auto-open */ }
        if (btn) {
          btn.textContent = 'Added';
          setTimeout(function () { btn.textContent = label; }, 2200);
        }
        return res;
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
        }
      });
  }

  window.tcsCart = { add: add, refreshBadge: refreshBadge };
})();
